// test1673
(1673 && 0);
